
/**
 * 트윗 유형
 */
export type ReferencedTweetSummaryBasicInfoAllOfTwoTweetType = typeof ReferencedTweetSummaryBasicInfoAllOfTwoTweetType[keyof typeof ReferencedTweetSummaryBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReferencedTweetSummaryBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
